module.exports = {"Domain":"域名","AppProfile":"专案","OriginPolicy":"回源政策","HtmlPage":"HTML页面","WafRule":"WAF规则","Cert":"凭证","ServiceGroup":"站点","SLB":"SLBS","VSLB":"虚拟SLBS","EDGE":"EDGES","DomainsWithAppProfile":"应用配置內的域名"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/zh-CN/resourceType.json
// module id = 5z1A
// module chunks = 3